var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00013 9C5.34327 9 4.00013 7.65685 4.00013 6C4.00013 4.34315 5.34327 3 7.00013 3C8.65698 3 10.0001 4.34315 10.0001 6C10.0001 7.65685 8.65698 9 7.00013 9ZM7.00013 7C6.44784 7 6.00013 6.55228 6.00013 6C6.00013 5.44772 6.44784 5 7.00013 5C7.55241 5 8.00013 5.44772 8.00013 6C8.00013 6.55228 7.55241 7 7.00013 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 6C20.0001 7.65685 18.657 9 17.0001 9C15.3432 9 14.0001 7.65685 14.0001 6C14.0001 4.34315 15.3432 3 17.0001 3C18.657 3 20.0001 4.34315 20.0001 6ZM18.0001 6C18.0001 6.55228 17.5524 7 17.0001 7C16.4478 7 16.0001 6.55228 16.0001 6C16.0001 5.44772 16.4478 5 17.0001 5C17.5524 5 18.0001 5.44772 18.0001 6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0001 12C15.0001 13.6569 13.657 15 12.0001 15C10.3432 15 9.0001 13.6569 9.0001 12C9.0001 10.3431 10.3432 9 12.0001 9C13.657 9 15.0001 10.3431 15.0001 12ZM13.0001 12C13.0001 12.5523 12.5524 13 12.0001 13C11.4478 13 11.0001 12.5523 11.0001 12C11.0001 11.4477 11.4478 11 12.0001 11C12.5524 11 13.0001 11.4477 13.0001 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99224 20.1251C9.17571 18.6701 10.0525 18 10.6794 18H13.3208C13.9477 18 14.8245 18.6701 15.008 20.1251C15.0771 20.6731 15.5773 21.0612 16.1252 20.9921C16.6732 20.923 17.0613 20.4228 16.9922 19.8749C16.7391 17.8675 15.3495 16 13.3208 16H10.6794C8.65071 16 7.26108 17.8675 7.00796 19.8749C6.93886 20.4228 7.32705 20.923 7.875 20.9921C8.42294 21.0612 8.92315 20.6731 8.99224 20.1251Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05365 12C5.14397 12 4.18424 12.7903 3.98996 14.1422C3.9114 14.6889 3.40455 15.0684 2.85788 14.9898C2.31121 14.9113 1.93174 14.4044 2.0103 13.8578C2.31357 11.7474 3.93678 10 6.05365 10H7.00013C7.55241 10 8.00013 10.4477 8.00013 11C8.00013 11.5523 7.55241 12 7.00013 12H6.05365Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0102 14.1422C19.8159 12.7903 18.8562 12 17.9465 12H17C16.4477 12 16 11.5523 16 11C16 10.4477 16.4477 10 17 10H17.9465C20.0633 10 21.6866 11.7474 21.9898 13.8578C22.0684 14.4044 21.6889 14.9113 21.1422 14.9898C20.5956 15.0684 20.0887 14.6889 20.0102 14.1422Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersTab);
export default __webpack_public_path__ + "static/media/users-tab.a169078e.svg";
export { ForwardRef as ReactComponent };